@if (isForbidLoading || isDepositForbid) {
  <deposit-withdraw-forbid [isLoading]="isForbidLoading"></deposit-withdraw-forbid>
} @else {
  <div class="scroll-cont">
    <div class="section">
      @if (!isConnected) {
        <div class="cont">
          <div class="title">Connect your Web3 wallet to Pubs for instant crypto deposits</div>
          <app-third-auth-m8 type="wallet" [isRegLogPage]="false"></app-third-auth-m8>
          @if (!isTgApp) {
            <cs-button
              color="accent"
              size="large"
              label="Connect your wallet"
              (buttonClick)="
                this.thirdAuthM8Service.handleAuth({
                  authName: ThirdAuthUser.WalletConnect,
                  isRegLogPage: false,
                })
              "
            ></cs-button>
          }
        </div>
      } @else {
        <div class="cont">
          <div class="row">
            <!-- 選擇bonus -->
            <div class="item">
              <app-deposit-bonus-dropdown
                [currentCurrency]="currentCurrency"
                (bonusLoadingChange)="isBonusLoading = $event"
              ></app-deposit-bonus-dropdown>
            </div>
          </div>
          <div class="row">
            <!-- 選擇幣別 -->
            <div class="item">
              <div class="label">
                <span>Select currency</span>
              </div>
              <cs-select
                [(value)]="selectedCurrencyOption"
                [options]="currencyOptions"
                (valueChange)="onCurrencySelectChange()"
              ></cs-select>
            </div>
            <!-- 選擇網路 -->
            <div class="item">
              <div class="label">
                <span>Select network</span>
              </div>
              <cs-select
                [(value)]="selectedNetworkOption"
                [options]="networkOptions"
                (valueChange)="onNetworkSelectChange()"
              ></cs-select>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <cs-input
                [label]="'From'"
                [readonly]="true"
                [value]="currentWeb3Wallet | web3WalletName"
                prefixImgUrl="/assets/images/login-wallets/{{ currentWeb3Wallet.toLocaleLowerCase() }}.svg"
                [marginBottom]="'0'"
              />
              <div class="msg">
                @if (!isHideWeb3Currency) {
                  {{ currentWeb3WalletBalance | currencyValue: currentCurrency }}{{ currentCurrency }}
                }
              </div>
            </div>

            <cs-button
              (buttonClick)="walletService.jump('withdraw', 'web3wallet')"
              [iconLeft]="'fi-switch-horizontal-filled'"
              [iconType]="'icon'"
              [color]="'secondary'"
              [size]="'default'"
              [width]="'38px'"
              [height]="'38px'"
            ></cs-button>
            <div class="item">
              <cs-input
                [label]="'To'"
                [readonly]="true"
                value="PUBS Wallet"
                prefixImgUrl="/assets/images/login-wallets/pubs.svg"
                [marginBottom]="'0'"
              />
              <div class="msg">{{ currentBalance | currencyValue: currentCurrency }}{{ currentCurrency }}</div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <cs-input
                [label]="'Deposit amount'"
                [inputMode]="'decimal'"
                [suffixText]="'Max'"
                [marginBottom]="'0'"
                (suffixIconClick)="onSetDepositMaxAmount()"
                [(value)]="amount"
                [hasError]="!amountValid"
                [errorHint]="errText"
                (valueChange)="onAmountInput()"
                [decimals]="currentDecimals"
                [disabled]="!selectedNetworkOption || !selectedCurrencyOption || isWeb3WalletLoading"
                input-float
              />
            </div>
          </div>
          <div class="row">
            <div class="item">
              <cs-button
                color="accent"
                size="large"
                label="Deposit"
                (buttonClick)="onWeb3Deposit()"
                [loading]="isAllLoading() || isTransacting"
                [disabled]="!isReadyToDeposit() || isTransacting"
              ></cs-button>
              <div class="confirm-note-list">
                <div class="confirm-note-item">
                  <i class="icon" class="fi-exclamation-circle-filled"></i>
                  <p>
                    The minimum deposit amount is
                    <span class="mark">
                      {{ selectedNetworkOption?.minAmount || 0 | number: '1.0-20' }} {{ currentCurrency }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="note">
        <span>Don’t have a wallet?</span>
        <cs-button
          (buttonClick)="walletService.jump('deposit', 'transfer')"
          color="secondary"
          width="auto"
          size="small"
          label="Transfer to crypto address"
        ></cs-button>
      </div>
    </div>
  </div>
}
